import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import ProtectedRoute from 'components/ProtectedRoute';
import DashboardLayout from 'layout/Dashboard';

// render - Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard')));

// render - Stores
const StoresList = Loadable(lazy(() => import('pages/stores')));
const StoreForm = Loadable(lazy(() => import('pages/stores/StoreForm')));

// render - Products
const ProductsList = Loadable(lazy(() => import('pages/products')));
const ProductForm = Loadable(lazy(() => import('pages/products/ProductForm')));

// render - Marcas
const MarcasList = Loadable(lazy(() => import('pages/marcas')));

// render - Promoters
const PromotersList = Loadable(lazy(() => import('pages/promoters')));
const PromoterForm = Loadable(lazy(() => import('pages/promoters/PromoterForm')));

// render - Visits
const VisitsList = Loadable(lazy(() => import('pages/visits')));
const VisitForm = Loadable(lazy(() => import('pages/visits/VisitForm')));
const VisitView = Loadable(lazy(() => import('pages/visits/VisitView')));
const VisitEdit = Loadable(lazy(() => import('pages/visits/VisitEdit')));
const VisitReport = Loadable(lazy(() => import('pages/visits/VisitReport')));

// render - Alerts
const AlertsList = Loadable(lazy(() => import('pages/alerts')));
const AlertView = Loadable(lazy(() => import('pages/alerts/AlertView')));

// render - Reports
const ReportsList = Loadable(lazy(() => import('pages/reports')));
const ReportView = Loadable(lazy(() => import('pages/reports/ReportView')));

// render - Pedidos
const PedidosList = Loadable(lazy(() => import('pages/pedidos')));
const PedidoForm = Loadable(lazy(() => import('pages/pedidos/PedidoForm')));

// render - Tasks
const TasksList = Loadable(lazy(() => import('pages/tasks')));
const TaskForm = Loadable(lazy(() => import('pages/tasks/TaskForm')));
const TaskView = Loadable(lazy(() => import('pages/tasks/TaskView')));

// render - Task Templates
const TaskTemplatesList = Loadable(lazy(() => import('pages/task-templates')));
const TaskTemplateForm = Loadable(lazy(() => import('pages/task-templates/TaskTemplateForm')));
const TaskTemplateView = Loadable(lazy(() => import('pages/task-templates/TaskTemplateView')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      path: '/',
      element: <Navigate to="/dashboard" replace />
    },
    {
      path: 'dashboard',
      element: <DashboardDefault />
    },
    {
      path: 'stores',
      children: [
        {
          path: '',
          element: <StoresList />
        },
        {
          path: 'create',
          element: <StoreForm />
        },
        {
          path: 'edit/:id',
          element: <StoreForm />
        }
      ]
    },
    {
      path: 'products',
      children: [
        {
          path: '',
          element: <ProductsList />
        },
        {
          path: 'create',
          element: <ProductForm />
        },
        {
          path: 'edit/:id',
          element: <ProductForm />
        }
      ]
    },
    {
      path: 'marcas',
      element: <MarcasList />
    },
    {
      path: 'promoters',
      children: [
        {
          path: '',
          element: <PromotersList />
        },
        {
          path: 'create',
          element: <PromoterForm />
        },
        {
          path: 'edit/:id',
          element: <PromoterForm />
        }
      ]
    },
    {
      path: 'visits',
      children: [
        {
          path: '',
          element: <VisitsList />
        },
        {
          path: 'report',
          element: <VisitReport />
        },
        {
          path: 'create',
          element: <VisitForm />
        },
        {
          path: 'view/:id',
          element: <VisitView />
        },
        {
          path: 'edit/:id',
          element: <VisitEdit />
        }
      ]
    },
    {
      path: 'alerts',
      children: [
        {
          path: '',
          element: <AlertsList />
        },
        {
          path: 'view/:id',
          element: <AlertView />
        }
      ]
    },
    {
      path: 'reports',
      children: [
        {
          path: '',
          element: <ReportsList />
        },
        {
          path: 'view/:id',
          element: <ReportView />
        }
      ]
    },
    {
      path: 'pedidos',
      children: [
        {
          path: '',
          element: <PedidosList />
        },
        {
          path: 'create',
          element: <PedidoForm />
        },
        {
          path: ':id/edit',
          element: <PedidoForm />
        }
      ]
    },
    {
      path: 'tasks',
      children: [
        {
          path: '',
          element: <TasksList />
        },
        {
          path: 'create',
          element: <TaskForm />
        },
        {
          path: 'edit/:id',
          element: <TaskForm />
        },
        {
          path: 'view/:id',
          element: <TaskView />
        }
      ]
    },
    {
      path: 'task-templates',
      children: [
        {
          path: '',
          element: <TaskTemplatesList />
        },
        {
          path: 'new',
          element: <TaskTemplateForm />
        },
        {
          path: ':id',
          element: <TaskTemplateView />
        },
        {
          path: ':id/edit',
          element: <TaskTemplateForm />
        }
      ]
    }
  ]
};

export default MainRoutes;
